"use strict";

/// <reference types="datatables.net"/>
$.fn.profilListAffaires = function () {
    $(this).click(function () {
        var $button = $(this);
        var $modal = $("#modal-profil-list-affaire");
        var $radios = $modal.find("input[type='radio']");
        var $input = $modal.find("input[name='libelle']");
        $radios.off().click(function () {
            if ($(this).val() != "" && $input.val() == "") {
                $input.val($(this).data("libelle"));
            }
        });
        $modal.find(".btn-success").off().click(function () {
            var libelle = $modal.find("input[name='libelle']").val();
            if (libelle == "") {
                return;
            }
            var $dt = $($button.data("target-datatable"));
            var $filters = $dt.find(".datatable-filter");
            // Profil de listing des affaires
            var profil = {
                columns: [],
                filters: [],
                ordering: [],
                pagination: $dt.find("div.dataTables_length select").val() //$dt.find(".page-length").val()
            };
            $.each($filters, function () {
                var $filter = $(this);
                var colName = $filter.data("column");
                profil.columns.push(colName);
                var $colElement = $filter.parents("th");
                if ($colElement) {
                    if ($colElement.hasClass("sorting_asc")) {
                        profil.ordering.push({
                            columnName: colName,
                            order: "ascending"
                        });
                    } else if ($colElement.hasClass("sorting_desc")) {
                        profil.ordering.push({
                            columnName: colName,
                            order: "descending"
                        });
                    }
                }
                // Filtre de type "multi valeurs"
                if ($filter.hasClass("datatable-filter-select2")) {
                    var data = $filter.select2("data").map(function (_) {
                        return _.id;
                    });
                    if (data && data.length) {
                        profil.filters.push({
                            columnName: colName,
                            operand: "contains",
                            value: data
                        });
                    }
                }
                // Filtre de type booléen
                else if ($filter.hasClass("datatable-filter-boolean")) {
                        var checked = $filter.is(":checked");
                        if (checked) {
                            profil.filters.push({
                                columnName: colName,
                                operand: "eq",
                                value: ["true"]
                            });
                        }
                    }
            });
            $.ajax({
                url: "/Affaires/SaveProfilListeAffaire",
                method: "post",
                data: {
                    configuration: JSON.stringify(profil),
                    libelle: libelle,
                    id: $modal.find("input[type='radio'][name='profil']:checked").val(),
                    parDefaut: $modal.find("input[type='radio'][name='par_defaut']:checked").val()
                },
                success: function success(d) {
                    document.location.reload(true);
                }
            });
        });
    });
    return $(this);
};
$.fn.selectProfilListAffaires = function () {
    var $select = $(this);
    var $dt = $($select.data("target-datatable"));
    var datatable = $dt.data("datatable");
    if (datatable) {
        // Activation de l'option "filtre personnalisé" du select
        $dt.on("filter-change", function (e, data) {
            var option = $select.find("option.custom").show().get(0);
            if (option) {
                $select.get(0).selectedIndex = -1;
                option.selected = true;
            }
            $dt.data("customVars", { profilId: "-1" });
        });
        $select.on("change", function () {
            // Reset datatable
            datatable.order([[0, "asc"]]).columns().search("");
            datatable.page.len($dt.find("div.dataTables_length select option:first" /*".page-length option:first"*/).val());
            // Reset filters
            $dt.find(".datatable-filter.datatable-filter-select2").html("");
            $dt.find(".datatable-filter.datatable-filter-boolean").prop("checked", false);
            $select.find("option.custom").hide();
            var $option = $select.find("option:selected");
            var value = $option.attr("value");
            $dt.data("customVars", {
                profilId: value
            });
            if (value && value != "0") {
                var config = $option.data("configuration");
                // Ordering
                if (config.ordering && config.ordering.length) {
                    var ordering = [];
                    for (var _i = 0, _a = config.ordering; _i < _a.length; _i++) {
                        var order = _a[_i];
                        var index = datatable.column(order.columnName + ":name").index();
                        ordering.push([index, order.order == 1 ? "asc" : "desc"]);
                    }
                    datatable.order(ordering);
                }
                // Filtrage
                if (config.filters && config.filters.length) {
                    for (var _b = 0, _c = config.filters; _b < _c.length; _b++) {
                        var filter = _c[_b];
                        if (filter.value == null || filter.value.length == 0) {
                            continue;
                        }
                        var valueString = filter.value.join(",");
                        // Filtrage dans datatables
                        var column = datatable.column(filter.columnName + ":name");
                        column.search(valueString);
                        // Mise à jour des inputs de filtre
                        var $filter = $dt.find(".datatable-filter[data-column=\"" + filter.columnName + "\"]");
                        // Filtre de type "multi valeurs"
                        if ($filter.hasClass("datatable-filter-select2")) {
                            $filter.html(filter.value.map(function (v) {
                                return "<option selected>" + v + "</option>";
                            }).join());
                        }
                        // Filtre de type booléen
                        else if ($filter.hasClass("datatable-filter-boolean")) {
                                $filter.prop("checked", valueString === "true");
                            }
                    }
                }
                // Colonnes à afficher
                //                if (config.columns && config.columns.length) {
                //                    datatable.columns().every(function () {
                //                        var visible = this.dataSrc().displayable;
                //                        this.visible(visible);
                //                    });
                //                }
                // Pagination
                if (config.pagination) {
                    datatable.page.len(config.pagination);
                }
            }
            $dt.find(".datatable-filter.datatable-filter-select2").trigger("change", { noRefresh: true });
            datatable.draw();
        });
        if ($select.val()) {
            $select.trigger("change");
        }
    }
    return $(this);
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/profilListe.ts
// module id = 534
// module chunks = 0